import { Component, contentChild, effect, ElementRef, TemplateRef } from "@angular/core";

@Component({
  selector: "app-validation-header",
  standalone: false,
  templateUrl: "./validation-header.component.html",
  styleUrl: "./validation-header.component.scss",
})
export class ValidationHeaderComponent {
  rightContentChild = contentChild<TemplateRef<any>>("rightContent");

  centerContentChild = contentChild<TemplateRef<any>>("centerContent");

  constructor() {}
}
